<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    max-width="800px"
    min-width="300px"
    scrollable
    @close="onDialogClose"
    :title="`${titleDialog} ${$t('sidebar.layer-group.name')}`"
    width="50%"
  >
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <v-row no-gutters>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.name"
            autofocus
            :error-messages="dialog.error.name"
            filled
            required
            :label="$t('map.form.name')"
            no-label
          ></field-group>
        </v-col>
        <v-col cols="12" v-if="!workspace_id">
          <field-group
            v-model="dialog.data.workspace_id"
            :error-messages="dialog.error.workspace_id"
            filled
            item-text="name"
            item-value="id"
            required
            :items="workspace.items"
            :label="$t('sidebar.workspace.name')"
            :loading="workspace.loading"
            typeInput="v-select"
          >
          </field-group>
        </v-col>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.abstractTxt"
            :error-messages="dialog.error.abstractTxt"
            filled
            :label="$t('map.form.abstractTxt')"
            no-label
            rows="2"
            typeInput="v-textarea"
          ></field-group>
          <LayerGroupWorkspaceLayerList v-model="dialog.data.layers" :wid="workspace_id" />
        </v-col>
      </v-row>
    </base-form>
    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="dialog.type"
        @click="onSubmit"
        :disabled="!dialog.data.layers.length"
      >
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import LayerGroupWorkspaceLayerList from './layer-group-workspace-layer-list.vue'
import { EDIT_TYPE } from '@constant'
import { API_LAYERGROUP, API_WORKSPACE } from '@api'
export default {
  props: {
    workspace_id: { type: [String, Number] },
  },
  components: { LayerGroupWorkspaceLayerList },
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {
        layers: [],
        layer_ids: [],
      },
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    default_params: {
      pagination: true,
      itemsPerPage: 5,
      loading: false,
    },
    workspace: { items: [], loading: true },
  }),
  created() {
    if (!this.workspace_id) {
      this.workspace.loading = true
      API_WORKSPACE.list({ sort: 'name' })
        .then((res) => {
          this.workspace.items = res.data
        })
        .finally(() => {
          this.workspace.loading = false
        })
    }
  },
  watch: {},
  computed: {
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    open(item, type = EDIT_TYPE.CREATE) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = type
      this.$set(
        this.dialog,
        'data',
        Object.assign({ layer_ids: [], layers: [] }, item)
      )
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {
          layers: [],
        },
        type: EDIT_TYPE.CREATE,
        error: {},
      }
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        let data = Object.assign({}, this.dialog.data)
        if (data.layers) {
          data.layer_ids = data.layers.map((x) => x.id)
          data.layers = []
        } else {
          data.layer_ids = []
        }
        this.dialog.loading = true
        let res = await API_LAYERGROUP.create(this.workspace_id, data)

        if (res && !res.error) {
          this.onDialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}
</style>
